




















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SubscriptionVm } from '../classes/subscriptionVm';
import { PaymentsApi } from '../api/payments';
import { loadStripe, Stripe, StripeElements, StripeElement, Card, StripeCardElement } from '@stripe/stripe-js';
import environment from '@/environment';
import BillingInformation from './BillingInformation.vue';
import { BillingModel } from '../../billing/classes/billing';
import AppMessage from '../../core/models/appMessage';
import { PaymentOptionsVm } from '../../payment-settings/classes/paymentOptions';
import { ProfileApi } from '../../profile/api/profile';

@Component({
  components: {
    BillingInformation,
  },
})

export default class Payment extends Vue {
  public loading: boolean = false;
  public key!: string;
  public subscription: SubscriptionVm = {
    subscriptionCode: '',
    allowedDevices: 0,
    allowedCallsMonthly: 0,
    externalSubscription: false,
    enabledFeatures: [],
    duration: new Date(),
    isDisplayed: false,
    amount: 0,
  };
  public cardError: string = '';
  public card!: StripeCardElement;
  public cards: Card[] = [];
  public selectedOption: string = '';
  private api!: PaymentsApi;
  private stripeApi!: Stripe;
  private stripeElements!: StripeElements;
  private billingData?: BillingModel;
  private isShopify: boolean = false;
  private hasShopifyIntegration: boolean = false;
  private profileApi: ProfileApi;

  constructor() {
    super();
    this.api = new PaymentsApi();
    this.profileApi = new ProfileApi();
  }

  public async created() {
    this.loading = true;
    this.key = this.$route.query.key as string;
    this.subscription = await this.api.getSubscriptionByCode(this.$route.query.subCode as string);
    const cards = await this.api.getCards();
    if (cards.data) {
      this.cards = cards.data;
    }

    const stripe = await loadStripe(environment.stripeKey);
    if (stripe) {
      this.stripeApi = stripe;
    } else {
      throw Error('failed to load stripe');
    }
    this.stripeElements = this.stripeApi.elements();

    this.initCardPaymentOption();
    if (this.cards.length === 0) {
      this.selectedOption = 'addNewCard';
      this.$nextTick().then(() => {
        this.createCardPaymentOption();
      });
    }

    const profile = await this.profileApi.getProfile();

    this.isShopify = profile.hadShopifyIntegration;
    this.hasShopifyIntegration = profile.hasShopifyIntegration;

    this.loading = false;
  }

  public cardChanged(selected: string) {
    if (selected === 'addNewCard') {
      this.$nextTick().then(() => {
        this.createCardPaymentOption();
      });
    }
  }

  public async pay() {
    this.loading = true;

    try {
      if (this.isShopify) {
        await this.shopifyPay();
      } else {
        await this.defaultPay();
      }
    } catch (error) {
      AppMessage.show(this.$t('payments.payment.error'), 'error');
    }

    this.loading = false;
  }

  public async defaultPay() {
    try {
      const isValid = await (this.$refs.billingInformation as BillingInformation).validateForm();

      if (isValid === false) {
        return;
      }
    } catch (error) {
      return false;
    }

    if (this.selectedOption === '') {
      AppMessage.show(this.$t('payments.payment.selectCardError'), 'error');
      return false;
    }

    (this.$refs.billingInformation as Vue & { submitForm: () => {}}).submitForm();
    this.billingData = (this.$refs.billingInformation as Vue & { billingForm: BillingModel }).billingForm;

    if (this.selectedOption !== 'addNewCard') {
        var paymentResponse = await this.api.pay({
          paymentMethodId: this.selectedOption,
          subscriptionCode: this.subscription.subscriptionCode,
          billingDetails: this.billingData!,
        });
        if(paymentResponse.status == 'use_stripe_sdk')
        {
          await this.stripeApi.confirmCardPayment(paymentResponse.clientSecret);
        }
    } else {
        const token = await this.stripeApi.createToken(this.card);

        var paymentResponse = await this.api.pay({
          cardToken: token.token!.id,
          subscriptionCode: this.subscription.subscriptionCode,
          billingDetails: this.billingData!,
        });
        if(paymentResponse.status == 'use_stripe_sdk')
        {
          await this.stripeApi.confirmCardPayment(paymentResponse.clientSecret);
        }
    }

    AppMessage.show(this.$t('payments.payment.success'), 'success');
    this.$router.push('/plan?currentPlan=' + this.subscription.subscriptionCode);
  }

  public async shopifyPay() {
    const result = await this.api.pay({
      paymentMethodId: 'shopify',
      subscriptionCode: this.subscription.subscriptionCode,
    });

    window.location.href = result.subscriptionId;
  }

  public installShopify() {
    window.location.href = 'https://shopify.com/';
  }

  public initCardPaymentOption() {
    this.card = this.stripeElements.create('card');
    this.card.on('change', (event) => {
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        this.cardError = '';
      }
    });
  }

  public createCardPaymentOption() {
    this.card.update({ hidePostalCode : true });
    this.card.mount('#card-element');
  }
}
